/* ═══════════════════════════════════════════════
   ink.IA — Carrito
   assets/ia-cart.js
   ═══════════════════════════════════════════════ */
 
(function () {
  'use strict';
 
  if (window.__iaCartLoaded) return;
  window.__iaCartLoaded = true;
 
  var root = document.querySelector('[data-ia-cart]');
  if (!root) return;
 
  var sectionId = root.dataset.sectionId;
  var trabajando = false;
 
  /* ── redibuja el carrito sin recargar la página ── */
  function refrescar() {
    return fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-ia-cart]');
        if (!nuevo) { window.location.reload(); return; }
        root.innerHTML = nuevo.innerHTML;
        actualizarBadge();
        return revisarRegalo();
      });
  }
 
  function bloquear(v) {
    trabajando = v;
    root.classList.toggle('is-busy', v);
  }
 
  /* ── cambiar cantidad o quitar ── */
  function cambiar(key, cantidad) {
    if (trabajando) return;
    bloquear(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: cantidad })
    })
      .then(function (r) { return r.json(); })
      .then(refrescar)
      .catch(function () { window.location.reload(); })
      .finally(function () { bloquear(false); });
  }
 
  /* ── agregar un producto ── */
  function agregar(id, propiedades) {
    if (trabajando) return;
    bloquear(true);
    var item = { id: Number(id), quantity: 1 };
    if (propiedades) item.properties = propiedades;
 
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json(); })
      .then(refrescar)
      .catch(function () { window.location.reload(); })
      .finally(function () { bloquear(false); });
  }
 
  /* ── el regalo se cae solo si el carrito baja del umbral ──
     Sin esto, alguien podría llegar al nivel, llevarse el regalo,
     sacar el producto caro y quedarse con el regalo gratis. */
  function revisarRegalo() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nivel = leerNivel();
        if (!nivel) return;
 
        var regalos = cart.items.filter(function (i) {
          return i.properties && i.properties._regalo;
        });
        if (!regalos.length) return;
 
        /* El total sin contar lo que valen los regalos */
        var sinRegalos = cart.items.reduce(function (acc, i) {
          var esRegalo = i.properties && i.properties._regalo;
          return esRegalo ? acc : acc + i.final_line_price;
        }, 0);
 
        if (sinRegalos < nivel) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: regalos[0].key, quantity: 0 })
          }).then(function () { return refrescar(); });
        }
      })
      .catch(function () {});
  }
 
  /* El nivel 2 sale del atributo que escribe la sección, en centavos */
  function leerNivel() {
    var v = Number(root.dataset.iaTier2);
    return isNaN(v) || v <= 0 ? null : v;
  }
 
  /* ── número del carrito en el header ── */
  function actualizarBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.ia-hd__badge');
        var icono = document.querySelector('.ia-hd__ic[href*="cart"]');
        if (badge) {
          if (cart.item_count > 0) badge.textContent = cart.item_count;
          else badge.remove();
        } else if (icono && cart.item_count > 0) {
          var s = document.createElement('span');
          s.className = 'ia-hd__badge';
          s.textContent = cart.item_count;
          icono.appendChild(s);
        }
      })
      .catch(function () {});
  }
 
  /* ── eventos ── */
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ia-qty]');
    if (q) {
      e.preventDefault();
      cambiar(q.dataset.iaQty, Number(q.dataset.v));
      return;
    }
 
    var g = e.target.closest('[data-ia-gift]');
    if (g) {
      e.preventDefault();
      agregar(g.dataset.iaGift, { _regalo: 'si' });
      return;
    }
 
    var a = e.target.closest('[data-ia-add]');
    if (a) {
      e.preventDefault();
      a.disabled = true;
      a.textContent = 'Agregando…';
      agregar(a.dataset.iaAdd);
      return;
    }
  });
 
  revisarRegalo();
})();